export default theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    textAlign: 'center',
  },
  content: {
    flexGrow: 1
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.secondary
  },
  details: {
    marginTop: theme.spacing(0),
    display: 'flex',
    alignItems: 'center'
  },
  profile: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  difference: {
    fontWeight: 700,
    marginLeft: theme.spacing(1),
    backgroundColor: theme.palette.danger.light,
    color: theme.palette.success.dark,
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
    borderRadius: '3px'
  },
  iconWrapper: {},
  icon: {
    color: theme.palette.text.secondary,
    opacity: 0.2,
    width: '4rem',
    height: '4rem',
    fontSize: '4rem'
  },
  div: {
    // backgroundColor: 'white',
    // border: '0px solid #000',
    width: '75vw',
    [theme.breakpoints.up('xs')]: {
        width: '75vw',
    },
    [theme.breakpoints.down('sm')]: {
        width: '100vw',
    },
  },
  headerTable:{
    backgroundColor: '#f57000',
    color: 'white'
  },
  updateTime:{
    fontWeight: 500,
    /* width: '200px' */
  },
  rounded: {
    color: '#3b3b3b',
    backgroundColor: '#fff',
    height: '30px'
  },
});
